import React, {Fragment} from 'react';
import _ from 'lodash';
import {getUrlParam} from './../../../utils/common';
import './index.scss';
import {connect} from 'react-redux';
import {getAuthUrl,getOauthInfo} from './../store/actionCreators';

class Oauth extends React.Component {
    constructor(props) {
        super(props);
        this.init();
    }

    init = () => {
        if ((!_.isEmpty(getUrlParam('code')))) {
            const data = {
                type: '1',
                code: getUrlParam('code')
            };
            // 回调方法，调用登录
            let storage = Storage.Base.getInstance();
            storage.set("code", data.code);
            window.location.href = `/login`;
            //this.memberLoginInfo(data);
        } else {
            // 获取授权路径
            this.getAuthUrl();
        }
    }

    async getAuthUrl() {
        const weChatUrl = await this.props.getAuthUrl();
        window.top.location.href = weChatUrl.data.wechatUrl;
    }

    render() {
        return (
            <Fragment>
            </Fragment>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        authInfo: state.home.authInfo
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getAuthUrl: () => {
            return dispatch(getAuthUrl({}))
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Oauth);

